<!--
 * @Description: 拣货表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-23 15:22:50
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-15 14:41:21
 -->
<template>
  <div>
    <div style="text-align: right;margin-bottom: 12px;">
      <el-button v-if="orderInfo.orderStatus === 'dcl' && $btnsPermission('outbound:dy')" @click="printPickingShow = true"><i class="el-icon-printer"></i>打印
      </el-button>
    </div>
    <div id="printweb" class="invoice_page">
      <div>
        <div>
          <div style="border:1px solid black;border-bottom:0px">
            <p class="title">
              拣货单
            </p>
            <div class="mainPrint">
              <img :src="orderInfo.qrCode" />
              <div class="printInfo">
                <div style="display: flex;">
                  <span class="label">单据编号：</span>
                  <div>
                    {{ orderInfo.bizId }}
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="item">
                    <span class="label">客户：</span>
                    <myTooltip class="info" :text="orderInfo.recipientInfoVo.customer">
                    </myTooltip>
                  </div>
                  <div class="item">
                    <span class="label">指定发货日期：</span>
                    <myTooltip class="info" style="left: 110px;" :text="orderInfo.specifyDeliveryDate">
                    </myTooltip>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="item">
                    <span class="label">销售部门：</span>
                    <myTooltip class="info" :text="orderInfo.applyOrgName">
                    </myTooltip>
                  </div>
                  <div class="item">
                    <span class="label">收件地址：</span>
                    <myTooltip class="info" :text="`${area}`">
                    </myTooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div style="width: 100%;">
          <table style="border-color:black;width: 100%;text-align: center;" border="1" cellpadding="8" cellspacing="0">
            <thead>
              <tr>
                <th style="padding: 1mm;">编号</th>
                <th style="padding: 1mm;">物料编号</th>
                <th style="padding: 1mm;">物料名称</th>
                <th style="padding: 1mm;">DI码</th>
                <th style="padding: 1mm;">规格型号</th>
                <th style="padding: 1mm;">批号</th>
                <th style="padding: 1mm;">数量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(info, i) in orderInfo.goodsVoList" :key="info.ogoodsId"
                :class="info.isParent === 'Y' ? 'gray' : ''">
                <td style="padding: 2mm;">{{ i + 1 }}</td>
                <td style="padding: 2mm;">{{ info.goodsCode }}</td>
                <td style="padding: 2mm;">{{ info.goodsName }}</td>
                <td style="padding: 2mm;">{{ info.diCode }}</td>
                <td style="padding: 2mm;">{{ info.specification }}</td>
                <td style="padding: 2mm;">{{ info.batchNumber }}</td>
                <td style="padding: 2mm;">{{ info.packageNumber }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="9" style="padding: 2mm;text-align: right;font-size: 14px;">
                  包装数量合计：{{ orderInfo.packageCount }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <printPicking v-if="printPickingShow" :order-ids="[orderInfo.orderId]" :visible="printPickingShow"
      @close="printPickingShow = false"></printPicking>
  </div>
</template>
<script>
import { getOrderInfo, updatePrintStatus } from '@/api/orderManage'
import PrintPicking from './PrintPicking'
import QRCode from 'qrcode'
export default {
  name: 'PrintPickingOne',
  components: { PrintPicking },
  data() {
    return {
      loading: false,
      printPickingShow: false,
      orderInfo: { recipientInfoVo: {} },
    }
  },
  computed: {
    area() {
      const { recipientInfoVo: { consigneeProvinceName = '', consigneeCityName = '', consigneeCountyName = '', customerAddress = '' } } = this.orderInfo
      return `${consigneeProvinceName}${consigneeCityName}${consigneeCountyName}${customerAddress}`
    }
  },
  methods: {
    getPrintInfo(crrData) {
      const { orderId } = crrData
      // 获取基础信息数据
      this.$emit('changeParentLoading', true)
      getOrderInfo(orderId).then(res => {
        this.orderInfo = res.data
        this.$set(this.orderInfo, 'packageCount', res.data.goodsVoList.reduce((a, b) => a + b.packageNumber, 0))
        QRCode.toDataURL(orderId)
          .then(url => {
            this.$set(this.orderInfo, 'qrCode', url)
          })
          .catch(err => {
            console.error(err)
          })
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
    printClick() {
      updatePrintStatus({ orderIdList: [this.orderInfo.orderId] })
    },
    callbackShutDownPage() {
      this.dialogTableVisible = false
    }
  }

}
</script>
<style lang="scss" scoped>
.title {
  text-align: center;
  margin: 0;
  padding: 2px 0;
  font-size: 18px;
  color: #333;
  font-weight: 700;
  border-bottom: 1px solid black;
  height: 10mm;
  box-sizing: border-box;
}

.mainPrint {
  display: flex;
  width: 100%;
  min-height: 25mm;
  padding: 12px 0;

  .printInfo {
    display: flex;
    width: 80%;
    flex-direction: column;
    min-height: 18mm;
    justify-content: space-between;

    .info {
      position: absolute;
      left: 80px;
      top: 0;
    }

    .item {
      position: relative;
      width: 50%;
    }
  }

  img {
    width: 20mm;
    height: 20mm;
    position: relative;
  }

}
</style>
